import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import {
  BEAR_CATEGORY,
  DADDY_CATEGORY,
  GIRLS_CATEGORY,
  S3_BUCKET_URL,
  SPORTY_CATEGORY,
  TWINK_CATEGORY,
  WOMEN_CATEGORY,
} from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LureScreenFooter } from '../../components/LureScreenFooter';
import { LayoutDataType } from '../../types';

import { ScreenAboutLookStyles } from './AboutLook.styles';

const MALE_CATEGORIES = [
  BEAR_CATEGORY,
  TWINK_CATEGORY,
  SPORTY_CATEGORY,
  DADDY_CATEGORY,
];

const getBgImageUrl = (gender: LayoutDataType['gender']): string => {
  if (gender === 'male') {
    return `${S3_BUCKET_URL}/layout-own-ai-man/bg-about-look.png`;
  }
  return `${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`;
};

export const ScreenAboutLook: React.FC = () => {
  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');
  const age = form.watch('age');

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  const handleNextStep = (): void => {
    if (gender === 'male') {
      userService.createOrUpdate({
        categories: MALE_CATEGORIES,
        onboarding_data: {
          first_categories: MALE_CATEGORIES,
        },
      });
      refreshUser();
    } else {
      const categoriesToPin =
        age === '50_plus' ? WOMEN_CATEGORY : GIRLS_CATEGORY;
      userService.createOrUpdate({
        categories: [categoriesToPin],
        onboarding_data: {
          first_categories: categoriesToPin,
        },
      });
    }
    wizard.nextStep();
  };

  const bgUrl = getBgImageUrl(gender ?? 'female');

  return (
    <ScreenAboutLookStyles bgImage={<img src={bgUrl} alt="Chat Vibe" />}>
      <IonContent>
        <OwnAiTitle className="local-title">
          Wow, That Look? Impressive!
        </OwnAiTitle>
        <OnboardingSubtitle>
          You've nailed the appearance—seriously, great choice! Now, let's dive
          into the personality. Ready to make them truly one of a kind?
        </OnboardingSubtitle>
      </IonContent>

      <LureScreenFooter onContinue={handleNextStep} />
    </ScreenAboutLookStyles>
  );
};
